<button class="question-bubble" (click)="onClick()">
  <span class="bubble-text">{{ text }}</span>
</button>